import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Spinner from "../../Common/Spinner";

const PreviewResumeModal = (props) => {
  const [isLoading, setLoading] = useState(true);
  const [resumeContent, setResumeContent] = useState("");

  useEffect(() => {
    setLoading(true);
    const resumeUrl =
      props.data?.resume_by_jobseeker || props.data?.jobseeker_resume || "";
    setResumeContent(resumeUrl);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [props.data?.resume_by_jobseeker, props.data?.jobseeker_resume]);

  const getViewerUrl = (url) => {
    return `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
      url
    )}`;
  };

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-lg"
    >
      <ModalHeader toggle={props.toggleModal}>
        {props.data?.resume_name || "Resume Preview"}
      </ModalHeader>
      <ModalBody className="text-center" style={{ height: "600px", position: "relative" }}>
        {isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100%" }}
          >
            <Spinner />
          </div>
        ) : resumeContent ? (
          <iframe
            title="Resume Preview"
            src={getViewerUrl(resumeContent)}
            style={{ border: 0 }}
            width="100%"
            height="100%"
            allowFullScreen
          />
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100%" }}
          >
            <p className="text-muted">Resume file not available</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={props.toggleModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PreviewResumeModal;
